// The Clavian mark (BRAND.md §2, Eclipse, ADR-0060): the kit's ClavianMark, drawn with the theme's tokens
// so a venue's brand override reaches it. Flat (an ink ring, a red keyhole) in the app's chrome; eclipse
// (the ring in the brand's light) on the sign-in page. Decorative: the link around it is named.

import { ClavianMark, type ClavianMarkVariant } from '@clavian/ui-web';

export function Mark({ size = 28, variant = 'flat' }: { readonly size?: number; readonly variant?: ClavianMarkVariant }) {
  return <ClavianMark className="pw-mark" variant={variant} size={size} />;
}

/** The brand lockup: the mark and the wordmark with its red stop. */
export function Wordmark({ size = 28 }: { readonly size?: number }) {
  return (
    <span className="pw-wordmark" aria-hidden="true">
      <Mark size={size} />
      <span className="pw-wordmark__text">
        Clavian<span className="pw-wordmark__stop">.</span>
      </span>
    </span>
  );
}
